<template>
<md-card>
    <header-form title="EDITAR FUNCIOÁRIO" :rota="{name: 'rhFuncionarioRead'}" tooltip="Lista de Funcionário" />

    <form @submit.prevent="update">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="dados.nome" type="text"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field>
                        <label>APELIDO</label>
                        <md-input v-model="dados.apelido" type="text"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nascimento }">
                        <label>DATA DE NASCIMENTO</label>
                        <md-input v-model="dados.nascimento" type="text" v-mask="'##/##/####'"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nascimento">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nascimento" class="validErro"> {{ errors.nascimento[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.sexo_id }">
                        <label for="sexo_id">SEXO</label>
                        <md-select v-model="dados.sexo_id" name="sexo_id">
                            <md-option value="1">MASCULINO</md-option>
                            <md-option value="2">FEMININO</md-option>
                            <md-option value="3">OUTROS</md-option>
                        </md-select>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.sexo_id">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.sexo_id" class="validErro"> {{ errors.sexo_id[0] }}</div>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.tipo_pessoa_id }">
                        <label for="tipo_pessoa_id">TIPO DE PESSOA</label>
                        <md-select v-model="dados.tipo_pessoa_id" name="tipo_pessoa_id">
                            <md-option value="1">FÍSICA</md-option>
                            <md-option value="2">JURÍDICA</md-option>
                        </md-select>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.tipo_pessoa_id">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.tipo_pessoa_id" class="validErro"> {{ errors.tipo_pessoa_id[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.cpf_cnpj }">
                        <label v-if="dados.tipo_pessoa_id == 2">CNPJ</label>
                        <label v-else>CPF</label>
                        <md-input v-if="dados.tipo_pessoa_id == 2" v-model="dados.cpf_cnpj" type="text" v-mask="'##.###.###/####-##'"> </md-input>
                        <md-input v-else v-model="dados.cpf_cnpj" type="text" v-mask="'###.###.###-##'"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.cpf_cnpj">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.cpf_cnpj" class="validErro"> {{ errors.cpf_cnpj[0] }}</div>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field>
                        <label>RG</label>
                        <md-input v-model="dados.rg" type="text"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field>
                        <label>MATRICULA</label>
                        <md-input v-model="dados.matricula" type="text" v-mask="'###########'"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field>
                        <label>UNIDADE</label>
                        <md-input v-model="dados.unidade" type="text" v-mask="'###'"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field>
                        <label>CONTRATO</label>
                        <md-input v-model="dados.contrato" type="text"> </md-input>
                    </md-field>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field>
                        <label>TELEFONE</label>
                        <md-input v-model="dados.telefone" type="text" v-mask="['(##) ####-####','(##) #####-####']"></md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field>
                        <label>CELULAR</label>
                        <md-input v-model="dados.celular" type="text" v-mask="['(##) ####-####','(##) #####-####']"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.email }">
                        <label>EMAIL</label>
                        <md-input v-model="dados.email" type="text" class="lowercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.email">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.email" class="validErro"> {{ errors.email[0] }}</div>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field>
                        <label>CEP</label>
                        <md-input v-model="dados.cep" type="text" v-mask="'#####-###'" @keyup="buscaCep"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                    <md-field>
                        <label>RUA</label>
                        <md-input v-model="dados.rua" type="text"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field>
                        <label>Nº</label>
                        <md-input v-model="dados.num" type="text"> </md-input>
                    </md-field>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <md-field>
                        <label>COMPLEMENTO</label>
                        <md-input v-model="dados.complemento" type="text"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field>
                        <label>BAIRRO</label>
                        <md-input v-model="dados.bairro" type="text"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field>
                        <label>CIDADE</label>
                        <md-input v-model="dados.cidade" type="text"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-10 md-xsmall-size-100">
                    <md-field>
                        <label>UF</label>
                        <md-input v-model="dados.uf" type="text"> </md-input>
                    </md-field>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import BuscarCep from '@/config/mixins/buscarCep'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },

    data() {
        return {
            dados: {
                tipo_pessoa_id: 1,
            },            
            errors: {}
        }
    },

    created() {
        this.getCliente();
    },

    mixins: [Notify, BuscarCep],

    methods: {

        getCliente() {
            this.$http.get(this.$urlAPI + 'clientes/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.dados = response.data.dados[0];
                        this.empresa = this.dados.empresa
                        this.plano = this.dados.plano
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        update() {
            this.$http.put(this.$urlAPI + 'clientes/' + this.dados.id, this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'rhFuncionarioRead'
                        });
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    }
};
</script>
